import React, { Fragment } from "react";
import FormControl from "@material-ui/core/FormControl";
import { InputLabel, MenuItem } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import { Skeleton } from "@material-ui/lab";
import { isBlank } from "../../util/ext";

const SubProjectSelect = props => {
  const { subProjects, onChange, value } = props;

  return (
    <Fragment>
      {isBlank(subProjects) ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth>
          <InputLabel htmlFor="content-audience">Sub Project</InputLabel>
          <Select
            value={value || ""}
            onChange={onChange}
            inputProps={{
              name: "sub-project",
              id: "sub-project",
            }}
          >
            {subProjects.map(sub => {
              return (
                <MenuItem value={sub.subProjectId} key={sub.subProjectId}>
                  {sub.subProjectName}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    </Fragment>
  );
};

export default SubProjectSelect;
